import React, { useRef, useEffect } from 'react';

/**
 * Component that alerts if you click outside of it
 */
const OutsideAlerter = (props) => {
	const { setSortOptions } = props;
	const wrapperRef = useRef(null);

	/**
	 * Hook that alerts clicks outside of the passed ref
	 */
	function useOutsideAlerter(ref) {
		useEffect(() => {
			/**
			 * Alert if clicked on outside of element
			 */
			function handleClickOutside(event) {
				if (ref.current && !ref.current.contains(event.target)) {
					setSortOptions(false);
				}
			}
			// Bind the event listener
			document.addEventListener('mousedown', handleClickOutside);
			return () => {
				// Unbind the event listener on clean up
				document.removeEventListener('mousedown', handleClickOutside);
			};
		}, [ref]);
	}

	useOutsideAlerter(wrapperRef);

	return <div ref={wrapperRef}>{props.children}</div>;
};

export default OutsideAlerter;
